interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  articlePublishedTime,
  articleModifiedTime,
}: SEOMetaProps) {
  const fullTitle = title.includes('紅桃視頻') ? title : `${title} - 紅桃視頻`;
  const fullOgTitle = ogTitle || fullTitle;
  const fullOgDescription = ogDescription || description;

  document.title = fullTitle;

  const setMeta = (name: string, content: string, isProperty = false) => {
    const attr = isProperty ? 'property' : 'name';
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('description', description);
  setMeta('keywords', keywords);

  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', canonicalUrl);

  setMeta('og:title', fullOgTitle, true);
  setMeta('og:description', fullOgDescription, true);
  setMeta('og:type', ogType, true);
  setMeta('og:url', canonicalUrl, true);
  setMeta('og:site_name', '紅桃視頻', true);
  setMeta('og:locale', 'zh_CN', true);
  if (ogImage) setMeta('og:image', ogImage, true);

  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', fullOgTitle);
  setMeta('twitter:description', fullOgDescription);
  if (ogImage) setMeta('twitter:image', ogImage);

  if (articlePublishedTime) setMeta('article:published_time', articlePublishedTime);
  if (articleModifiedTime) setMeta('article:modified_time', articleModifiedTime);

  return null;
}